import { cloneDeep } from 'lodash-es'

import { EMPLOYEE_KPIS_LOCAL_STORAGE_KEY } from 'src/pages/site/Sales/components/Popovers/EmployeeFeaturedMetricsPopover/constants'

const initialState = {
  employeeKpis: [],
  isPersonsLoading: false,
  persons: {},
  personsPeriods: null,
}

export default {
  namespaced: true,
  state: cloneDeep(initialState),
  mutations: {
    RESET(state) {
      const clonedInitialState = cloneDeep(initialState)

      for (const key in clonedInitialState) {
        if (Object.hasOwnProperty.call(clonedInitialState, key)) {
          state[key] = clonedInitialState[key]
        }
      }
    },
    SET_EMPLOYEE_KPIS(state, payload) {
      state.employeeKpis = payload
    },
    ADD_EMPLOYEE_KPI(state, payload) {
      state.employeeKpis = [...state.employeeKpis, payload]
    },
    REMOVE_EMPLOYEE_KPI(state, payload) {
      state.employeeKpis = state.employeeKpis.filter((metric) => metric !== payload)
    },
    SET_PERSONS_LOADING(state, payload) {
      state.isPersonsLoading = payload
    },
    SET_PERSONS(state, payload) {
      state.persons = payload
    },
    SET_PERSONS_PERIODS(state, payload) {
      state.personsPeriods = payload
    },
  },
  actions: {
    addKpi({ state, commit }, metric) {
      commit('ADD_EMPLOYEE_KPI', metric)
      localStorage.setItem(EMPLOYEE_KPIS_LOCAL_STORAGE_KEY, JSON.stringify(state.employeeKpis))
    },
    removeKpi({ state, commit }, metric) {
      commit('REMOVE_EMPLOYEE_KPI', metric)
      localStorage.setItem(EMPLOYEE_KPIS_LOCAL_STORAGE_KEY, JSON.stringify(state.employeeKpis))
    },
  },
}
